/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountCode,
    AccountCodeFromJSON,
    AccountCodeFromJSONTyped,
    AccountCodeToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CardPoolSetting,
    CardPoolSettingFromJSON,
    CardPoolSettingFromJSONTyped,
    CardPoolSettingToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsCreateRequest
 */
export interface VccCredentialsCreateRequest {
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof VccCredentialsCreateRequest
     */
    cardSupplier?: GuidIdAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof VccCredentialsCreateRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<AccountCode>}
     * @memberof VccCredentialsCreateRequest
     */
    accountCodes?: Array<AccountCode> | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    zip?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsCreateRequest
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsCreateRequest
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsCreateRequest
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof VccCredentialsCreateRequest
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    agentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    apiKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    consumer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    server?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    organisationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    merchantId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    bankId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsCreateRequest
     */
    companyId?: string | null;
    /**
     * 
     * @type {Array<CardPoolSetting>}
     * @memberof VccCredentialsCreateRequest
     */
    cardPoolSettings?: Array<CardPoolSetting> | null;
}

export function VccCredentialsCreateRequestFromJSON(json: any): VccCredentialsCreateRequest {
    return VccCredentialsCreateRequestFromJSONTyped(json, false);
}

export function VccCredentialsCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardSupplier': !exists(json, 'cardSupplier') ? undefined : GuidIdAndLabelFromJSON(json['cardSupplier']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(AccountCodeFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'addressLine1': !exists(json, 'addressLine1') ? undefined : json['addressLine1'],
        'addressLine2': !exists(json, 'addressLine2') ? undefined : json['addressLine2'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'agentId': !exists(json, 'agentId') ? undefined : json['agentId'],
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
        'bookerId': !exists(json, 'bookerId') ? undefined : json['bookerId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'consumer': !exists(json, 'consumer') ? undefined : json['consumer'],
        'server': !exists(json, 'server') ? undefined : json['server'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'merchantId': !exists(json, 'merchantId') ? undefined : json['merchantId'],
        'bankId': !exists(json, 'bankId') ? undefined : json['bankId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'cardPoolSettings': !exists(json, 'cardPoolSettings') ? undefined : (json['cardPoolSettings'] === null ? null : (json['cardPoolSettings'] as Array<any>).map(CardPoolSettingFromJSON)),
    };
}

export function VccCredentialsCreateRequestToJSON(value?: VccCredentialsCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardSupplier': GuidIdAndLabelToJSON(value.cardSupplier),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(AccountCodeToJSON)),
        'description': value.description,
        'email': value.email,
        'url': value.url,
        'addressLine1': value.addressLine1,
        'addressLine2': value.addressLine2,
        'city': value.city,
        'country': value.country,
        'zip': value.zip,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'password': value.password,
        'agentId': value.agentId,
        'apiKey': value.apiKey,
        'bookerId': value.bookerId,
        'clientId': value.clientId,
        'consumer': value.consumer,
        'server': value.server,
        'username': value.username,
        'organisationId': value.organisationId,
        'merchantId': value.merchantId,
        'bankId': value.bankId,
        'companyId': value.companyId,
        'cardPoolSettings': value.cardPoolSettings === undefined ? undefined : (value.cardPoolSettings === null ? null : (value.cardPoolSettings as Array<any>).map(CardPoolSettingToJSON)),
    };
}


